import {ItemToolEditor} from "./CreatePriceGroup.jsx";
export default function CreateCategory(props){return <ItemToolEditor {...props} kind="category"/>;}
